import React from 'react';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import MobileUpcomingGame from '@/pages/intelligence/pages/Potential/UpcomingGames/MobileGame';

interface IUpcomingProps {
  /** TopCharts 主入口显式传递；Potential 复用入口不传时沿用 common 作用域。 */
  pageId?: string;
}

export default function Upcoming({ pageId }: IUpcomingProps) {
  const pageLogInfo = dbiPageLogMes.topchartsMobileGamesUpcoming;
  const entityType = 'mobile';
  return (
    <>
      <MarqueeBanner />
      <MobileUpcomingGame entityType={entityType} pageLogInfo={pageLogInfo} pageId={pageId} enableDefaultCheck={false} enableStickyFilter enableMobileTopChartsFilterHoverTips />
    </>
  );
}

